module.exports = __webpack_public_path__ + "media/video/claims_video-17dba5134f1bd1d426e527fcd395088c.mp4";